
import { Mapper } from "../../../../base/utils/mapper";
import { ArcMotionPhysiotherapyResponseModel } from "../../../../domain/models/consult/arc-motion-physiotherapy-response.models";
import { ArcMotionPhysiotherapyResponseEntity } from "../entities/arc-motion-physiotherapy-response.entity";


 export class ArcMotionPhysiotherapyImplementationRepositoryMapper extends Mapper<ArcMotionPhysiotherapyResponseEntity, ArcMotionPhysiotherapyResponseModel>{
            mapFrom(param:  ArcMotionPhysiotherapyResponseEntity):  ArcMotionPhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param: ArcMotionPhysiotherapyResponseModel):  ArcMotionPhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }